module.exports = __webpack_public_path__ + "02a7481b01989ad3fff11349f8cd7d02.svg";